import { render, staticRenderFns } from "./Referat.vue?vue&type=template&id=9b9a4296&lang=pug&"
import script from "./Referat.vue?vue&type=script&lang=ts&"
export * from "./Referat.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports